



















































































import {
  BankCustodian,
  PartnerContentType
} from "@/admin/types";
import { Validator } from "vee-validate";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerContentStore } from "@/shared/store/partnerContent";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class PartnerContentSection extends Vue {
  @Prop() partnerId: number;
  @Prop() custodian: BankCustodian;

  $validator: Validator;
  isSaving = false;

  partnerContentModel = {
    content: ""
  };

  footerContentModel = {
    content: ""
  };

  portalFooterTextModel = {
    content: ""
  };

  notifierStore = useNotifierStore();
  partnerContentStore = usePartnerContentStore();

  mounted () {
    this.onPartnerIdChange();
    this.onPartnerContentLoaded();
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.partnerContentStore.getPartnerContent(this.partnerId);
  }

  @Watch("isLoading")
  onPartnerContentLoaded () {
    if (!this.isLoading) {
      this.partnerContentModel = {
        content: this.partnerContentStore.partnerContent.drivewealthInvestmentPromo || ""
      };

      this.footerContentModel = {
        content: this.partnerContentStore.partnerContent.footer || ""
      };

      this.portalFooterTextModel = {
        content: this.partnerContentStore.partnerContent.postLoginFooter || ""
      };
    }
  }

  get isLoading () {
    return this.partnerContentStore.isLoadingContent;
  }

  get isLoaded () {
    return this.partnerContentStore.isLoadedContent;
  }

  onSave () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          const content: Record<PartnerContentType, string> = {
            drivewealthInvestmentPromo: this.partnerContentModel.content || "",
            footer: this.footerContentModel.content || "",
            postLoginFooter: this.portalFooterTextModel.content || "",
          };

          this.isSaving = true;
          this.partnerContentStore.savePartnerContent({ partnerId: this.partnerId, content })
              .then(() => {
                this.notifierStore.setSuccess("Partner content saved.");
              })
              .finally(() => this.isSaving = false);
        });
  }
}
